import Rest from '@/services/Rest';

/**
 * @typedef {CoSellerService}
 */
export default class CoSellerService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/co-seller'
}